export default "__VITE_ASSET__5b31b4c8__"